import React from 'react'
import connect from "react-redux/es/connect/connect"
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'

import {
  findOneBy,
} from '@relativity/js-util'

import {
  bellRulesEditDone,
  bellRulesEditUpdateProperty,
  bellRulesEditSave,
  resetCurrentBellScheduleWarnings
} from 'redux/admin/Actions'

import BellRuleSVGHorizontal from "common/components/BellRuleSVGHorizontal"
import PillToggle from "common/components/PillToggle"
import styles from './style'
import {AT_TYPE_ID_NOT_SET, AT_TYPE_ID_PRESENT, paModeList, IS_TEACHER_REVIEW_ENABLED, PERIOD_RULE_AT_TYPE_TITLE_MAP} from "redux/constants";
import {FullTextFieldD} from "common/components/FullTextField";
import {Divider} from "@material-ui/core";

import {minuteList, presentMinuteList} from './objects'
import PassiveIconButton from "common/components/PassiveIconButton";
import Typography from "@material-ui/core/es/Typography";
import {BELL_RULE_TOOLTIPS, BELL_RULE_LABELS} from './texts'

class BellRulesDialog extends React.Component {
  componentWillUnmount() {
    this.props.resetCurrentBellScheduleWarnings()
  }

  render() {
    if(!this.props.bellSchedule) return null

    const {
      classes,
      bellSchedule,
      facilities,
      positiveAttendanceIsEnabled,
      zeroFacility,
      allAtTypes
    } = this.props

    let atTypes = findOneBy(facilities, 'id', bellSchedule.facilityId).atTypes.slice()
    atTypes.unshift(findOneBy(zeroFacility.atTypes, 'id', AT_TYPE_ID_PRESENT))
    atTypes.unshift(findOneBy(zeroFacility.atTypes, 'id', AT_TYPE_ID_NOT_SET))

    let atReasons = findOneBy(facilities, 'id', bellSchedule.facilityId).atReasons.slice()
    atReasons.unshift(findOneBy(zeroFacility.atReasons, 'id', AT_TYPE_ID_NOT_SET))

    const facilityOverridableAtTypes = allAtTypes
      .filter(atType => atType.facilityId === bellSchedule.facilityId && atType.kioskCanOverride);

    const overridableAtTypeNames = facilityOverridableAtTypes.map(atType => atType.name).sort().join(', ');

    const overridableAtTypesInfo = facilityOverridableAtTypes.length > 0
    ? `${facilityOverridableAtTypes.length} attendance types are allowed to be overridden by the kiosk entry: ${overridableAtTypeNames}`
    : "No attendance types are allowed to be overridden by the kiosk entry";

    const bellScheduleAtTypeId = bellSchedule.atTypePresentId === AT_TYPE_ID_NOT_SET ? AT_TYPE_ID_PRESENT : bellSchedule.atTypePresentId;
    
    return (
          <Grid container>
            <Grid item sm={12} md={10} lg={8}>

              {positiveAttendanceIsEnabled &&
                <Grid item xs={12} className={`${classes.gridItem} ${classes.paGridItem}`}>
                  <Tooltip title={BELL_RULE_TOOLTIPS.isPaEnabled}>
                    <PillToggle
                      isOn={bellSchedule.isPaEnabled}
                      label={BELL_RULE_LABELS.positiveAttendance}
                      disabled
                    />
                  </Tooltip>
                </Grid>
              }

              {/* === Attendance Codes === */}
              <Grid item xs={12} className={classes.gridItem}>
                <Typography className={classes.sectionLabel}>
                  {BELL_RULE_LABELS.sectionAttendanceCodes}
                </Typography>
                <Divider className={classes.sectionDivider} />
              </Grid>
              <Grid container>

                <Grid item xs={6} className={classes.gridItem}>
                  <FullTextFieldD
                    label={PERIOD_RULE_AT_TYPE_TITLE_MAP['atTypeTardyId']}
                    value={findOneBy(atTypes, 'id', bellSchedule.atTypeTardyId)['displayName']}
                  />
                </Grid>
                <Grid item xs={6} className={classes.gridItem}>
                  <FullTextFieldD
                    label={PERIOD_RULE_AT_TYPE_TITLE_MAP['atTypeTardyExcusedId']}
                    value={findOneBy(atTypes, 'id', bellSchedule.atTypeTardyExcusedId)['displayName']}
                  />
                </Grid>

                <Grid item xs={6} className={classes.gridItem}>
                  <FullTextFieldD
                    label={PERIOD_RULE_AT_TYPE_TITLE_MAP['atTypeAbsentId']}
                    value={findOneBy(atTypes, 'id', bellSchedule.atTypeAbsentId)['displayName']}
                  />
                </Grid>
                <Grid item xs={6} className={classes.gridItem}>
                  <FullTextFieldD
                    label={PERIOD_RULE_AT_TYPE_TITLE_MAP['atTypeAbsentExcusedId']}
                    value={findOneBy(atTypes, 'id', bellSchedule.atTypeAbsentExcusedId)['displayName']}
                  />
                </Grid>

                <Grid item xs={6} className={classes.gridItem}>
                  <FullTextFieldD
                    label={BELL_RULE_LABELS.atReasonDefaultId}
                    value={findOneBy(atReasons, 'id', bellSchedule.atReasonDefaultId)['displayName']}
                  />
                </Grid>
                <Grid item xs={6} className={classes.gridItem}>
                  <FullTextFieldD
                    label={PERIOD_RULE_AT_TYPE_TITLE_MAP['atTypeOutOfBuildingId']}
                    value={findOneBy(atTypes, 'id', bellSchedule.atTypeOutOfBuildingId)['displayName']}
                  />
                </Grid>

                {positiveAttendanceIsEnabled && bellSchedule.isPaEnabled &&
                  <Grid item xs={6} className={classes.gridItem}>
                    <FullTextFieldD
                      label={BELL_RULE_LABELS.atTypePresentId}
                      value={findOneBy(atTypes, 'id', bellScheduleAtTypeId)['displayName']}
                    />
                  </Grid>
                }
              </Grid>

              {/* === Attendance Timing Thresholds === */}
              <Grid item xs={12} className={`${classes.gridItem} ${classes.sectionHeader}`}>
                <Typography className={classes.sectionLabel}>
                  {BELL_RULE_LABELS.sectionTimingThresholds}
                </Typography>
                <Divider className={classes.sectionDivider} />
              </Grid>
              <Grid container>
                {positiveAttendanceIsEnabled && bellSchedule.isPaEnabled &&
                  <Grid item xs={4} className={classes.gridItem}>
                      <Tooltip title={BELL_RULE_TOOLTIPS.bellPeriodPreStartPresentSeconds}>
                        <div className={classes.fieldWithIndicator}>
                          <FullTextFieldD
                            label={BELL_RULE_LABELS.bellPeriodPreStartPresentSeconds}
                            value={findOneBy(presentMinuteList, 'seconds', bellSchedule.bellPeriodPreStartPresentSeconds)['displayName']}
                          />
                          <div className={classes.presentIndicator} />
                        </div>
                      </Tooltip>
                    </Grid>
                  }

                  <Grid item xs={4} className={classes.gridItem}>
                    <Tooltip title={BELL_RULE_TOOLTIPS.bellPeriodPostStartTardySeconds}>
                      <div className={classes.fieldWithIndicator}>
                        <FullTextFieldD
                          label={BELL_RULE_LABELS.bellPeriodPostStartTardySeconds}
                            value={findOneBy(minuteList, 'seconds', bellSchedule.bellPeriodPostStartTardySeconds)['displayName']}
                        />
                        <div className={classes.tardyIndicator} />
                      </div>
                    </Tooltip>
                  </Grid>
                        
                  <Grid item xs={4} className={classes.gridItem}>
                    <Tooltip title={BELL_RULE_TOOLTIPS.bellPeriodPostStartAbsentSeconds}>
                      <div className={classes.fieldWithIndicator}>
                        <FullTextFieldD
                          label={BELL_RULE_LABELS.bellPeriodPostStartAbsentSeconds}
                          value={findOneBy(minuteList, 'seconds', bellSchedule.bellPeriodPostStartAbsentSeconds)['displayName']}
                        />
                        <div className={classes.absentIndicator} />
                      </div>
                    </Tooltip>
                  </Grid>
                <Grid item xs={12} className={`${classes.gridItem} ${classes.svgContainer}`}>
                  <div className={classes.bellIconWrapper}>
                    <img src="/school-bell.png" alt="Fire alarm icons created by Freepik - Flaticon" title="Timeline diagram showing when attendance codes take effect relative to the bell: early/on-time present before and at bell, tardy after the tardy threshold, and absent after the absent threshold." className={classes.bellIcon} />
                    <Typography className={classes.bellIconLabel}>minutes</Typography>
                  </div>
                  <BellRuleSVGHorizontal style={{maxWidth:'100%', flex: 1}} {...bellSchedule} positiveAttendanceIsEnabled={positiveAttendanceIsEnabled && bellSchedule.isPaEnabled}/>
                </Grid>
              </Grid>

              {/* === Attendance Logic === */}
              <Grid item xs={12} className={`${classes.gridItem} ${classes.sectionHeader}`} style={{marginTop: 0}}>
                <Typography className={classes.sectionLabel}>
                  {BELL_RULE_LABELS.sectionAttendanceLogic}
                </Typography>
                <Divider className={classes.sectionDivider} />
              </Grid>
              <Grid item xs={12} className={classes.gridItem}>
                <Tooltip title={BELL_RULE_TOOLTIPS.overridableAtTypes}>
                <Typography className={classes.summaryLogicText}>
                  {BELL_RULE_LABELS.kioskOverwritePermission}: {overridableAtTypesInfo.replace(/^[^:]+: /, '')}
                </Typography>
                </Tooltip>
              </Grid>
              <Grid container>
                <Grid item xs={12} className={classes.gridItem}>
                  <Tooltip title={BELL_RULE_TOOLTIPS.isOutOfBuildingPropagationEnabled}>
                  <Typography className={classes.summaryLogicText}>
                    <PassiveIconButton onTitle='Enabled' offTitle='Disabled' isOn={!!bellSchedule.isOutOfBuildingPropagationEnabled}/>
                    {BELL_RULE_LABELS.isOutOfBuildingPropagationEnabled}
                  </Typography>
                  </Tooltip>
                </Grid>
                {positiveAttendanceIsEnabled &&
                  <Grid item xs={12} className={classes.gridItem}>
                    <Tooltip title={BELL_RULE_TOOLTIPS.isNonAttendancePeriodsEnabled}>
                    <Typography className={classes.summaryLogicText}>
                      <PassiveIconButton onTitle='Enabled' offTitle='Disabled' isOn={!!bellSchedule.isNonAttendancePeriodsEnabled}/>
                      {BELL_RULE_LABELS.isNonAttendancePeriodsEnabled}
                    </Typography>
                    </Tooltip>
                  </Grid>
                }
                <Grid item xs={12} className={classes.gridItem}>
                  <Tooltip title={BELL_RULE_TOOLTIPS.isCreateInOutsEnabled}>
                  <Typography className={classes.summaryLogicText}>
                    <PassiveIconButton onTitle='Enabled' offTitle='Disabled' isOn={!!bellSchedule.isCreateInOutsEnabled}/>
                    {BELL_RULE_LABELS.isCreateInOutsEnabled}
                  </Typography>
                  </Tooltip>
                </Grid>
              </Grid>

              {IS_TEACHER_REVIEW_ENABLED &&
                <Grid container>
                  <Grid item xs={12} className={classes.gridItem}>
                    <Tooltip title={BELL_RULE_TOOLTIPS.isAttendanceApproveRequired}>
                    <Typography className={classes.summaryLogicText}>
                      <PassiveIconButton onTitle='Enabled' offTitle='Disabled' isOn={!!bellSchedule.isAttendanceApproveRequired}/>
                      {BELL_RULE_LABELS.isAttendanceApproveRequired}
                    </Typography>
                    </Tooltip>
                  </Grid>
                </Grid>
              }          
            </Grid>
          </Grid>

    )
  }
}

const mapStateToProps = state => {
  const adminState = state.admin;
  const atTypes = state.admin.atTypes ? state.admin.atTypes.filter(atType => atType.facilityId === state.admin.currentFacilityId) : [];

  return {
    ...adminState,
    allAtTypes: atTypes
  };
}

const mapDispatchToProps = {
  bellRulesEditDone,
  bellRulesEditUpdateProperty,
  bellRulesEditSave,
  resetCurrentBellScheduleWarnings
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(BellRulesDialog))